import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useT } from "../i18n/I18nContext";
import { toast } from "sonner";
import { FolderKanban, PlusCircle, Trash2 } from "lucide-react";

export default function AdminGroupsPage() {
  const t = useT();
  const [groups, setGroups] = useState([]);
  const load = async () => {
    const { data } = await api.get("/groups");
    setGroups(data);
  };
  useEffect(() => { load(); }, []);

  const removeGroup = async (e, g) => {
    e.preventDefault();
    e.stopPropagation();
    if (!window.confirm(t("admin.groups.confirm_delete"))) return;
    try {
      await api.delete(`/groups/${g.id}`);
      toast.success(t("group.toast.deleted"));
      await load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div className="max-w-6xl mx-auto px-5 md:px-8 py-8">
      <div className="flex items-start justify-between mb-6 flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <FolderKanban className="w-6 h-6 text-[#0F4C3A]" />
          <h1 className="font-heading text-2xl md:text-3xl font-medium text-[#0F4C3A]" data-testid="admin-groups-title">{t("admin.groups.title")}</h1>
        </div>
        <Link to="/admin/groups/new" data-testid="new-group-link" className="nv-btn-primary px-4 py-2 rounded-md font-medium inline-flex items-center gap-2 text-sm">
          <PlusCircle className="w-4 h-4" /> {t("admin.groups.new_group")}
        </Link>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        {groups.map((g) => (
          <Link key={g.id} to={`/admin/groups/${g.id}`} data-testid={`group-card-${g.id}`} className="nv-border bg-white rounded-md p-5 hover:border-[#0F4C3A] transition">
            <div className="flex items-start justify-between gap-2">
              <div>
                <div className="font-heading text-lg font-medium text-[#0F4C3A]">{g.name}</div>
                <div className="text-sm text-[#475569] mt-1">{g.shares} · {t("dashboard.month")} {g.current_month}</div>
              </div>
              <div className="flex items-center gap-2">
                <div className="text-xs uppercase tracking-wider text-[#94A3B8] whitespace-nowrap">{g.status}</div>
                <button onClick={(e) => removeGroup(e, g)} data-testid={`delete-group-${g.id}`} className="p-1.5 text-[#DC2626] hover:bg-[#FEE2E2] rounded">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
            <div className="nv-label mt-4">{t("admin.groups.start")}</div>
            <div className="font-mono-nv text-sm text-[#0F4C3A]">{g.start_date}</div>
          </Link>
        ))}
        {groups.length === 0 && (
          <div className="sm:col-span-2 nv-border bg-white p-10 text-center text-[#94A3B8] rounded-md">{t("admin.groups.no_groups")}</div>
        )}
      </div>
    </div>
  );
}
